import React from "react";

import Divider from "@mui/material/Divider";
import Button from '@mui/material/Button';
import PictureAsPdf from "@mui/icons-material/PictureAsPdf"

import SummaryBox, { SummaryBoxRowCenter, SummaryBoxRowImage, SummaryBoxRowLabelValue } from "@refere/ui-utils/ui/components/SummaryBox";

import { useHookstate } from "@hookstate/core";

import { mostraCpfFormatado, mostraFormatadoEmReais } from "@refere/ui-utils/ui/utils/format";

import { globalState } from "../../../features/global-state";
import { enumPasso } from "../../../features/simulacao";
import { downloadPdfCotacao } from "../../../features/summaryBox";


const _SummaryBox = () => {
    const simulacaoState = useHookstate(globalState.simulacao);

    const simulacao = simulacaoState?.get();
    const summaryBox = simulacao?.summaryBox;

    return (
        <>
        {
            simulacao &&
            <SummaryBox>
                <SummaryBoxRowImage 
                    imageSrcBase64={summaryBox.corretoraImageBase64}
                    imageStyle={{
                        width: "100px"
                    }}
                />
                <SummaryBoxRowCenter sx={{ mb: 2 }}>
                    {summaryBox.nome}
                </SummaryBoxRowCenter>
                <Divider />
                <SummaryBoxRowLabelValue
                    label="Cotação"
                    value={simulacao.idSimulacao.toString()}
                />
                <SummaryBoxRowLabelValue
                    label="CPF"
                    value={mostraCpfFormatado(summaryBox.cpf)}
                />
                {
                    simulacao.passo >= enumPasso.contratacao &&
                    <>
                        <Divider sx={{ mt: 1 }} />
                        <SummaryBoxRowImage 
                            sx={{ mt: 2 }}
                            imageSrcBase64={summaryBox.seguradoraImageBase64}
                            imageStyle={{
                                width: "100px"
                            }}
                        />
                        <SummaryBoxRowLabelValue
                            label="Plano"
                            value={summaryBox.plano}
                        />
                        <SummaryBoxRowLabelValue
                            label="Valor Mensal"
                            value={mostraFormatadoEmReais(summaryBox.vlrPremio)}
                        />
                    </>
                }
                {
                    simulacao.passo === enumPasso.contratacao &&
                    <SummaryBoxRowCenter sx={{ mt: 1, mb: 1 }}>
                        <Button variant="outlined" endIcon={<PictureAsPdf />} sx={{ textTransform: "none" }}
                            onClick={async () => await downloadPdfCotacao() } >
                            Visualizar Cotação
                        </Button>
                    </SummaryBoxRowCenter>
                }                                
            </SummaryBox>
        }
        </>
    );
}

export default _SummaryBox;